module.exports = __webpack_public_path__ + "static/media/Sopp.8edbe11c.PNG";